export default __webpack_public_path__ + "static/media/refNo_mail.ad0f9f65.jpg";